import { API } from '../helpers/fetcher'

export const getPaymentLink = () => API.get('v1/transaction/link')
